import { z } from 'zod';

const RoleInfoSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  slug: z.string(),
  is_system: z.boolean(),
});

export const ProfileSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  role_id: z.string().uuid().nullable(),
  role: RoleInfoSchema.nullable(),
  created_at: z.string().datetime(),
});

/** Strong password: 8+ chars, at least one uppercase letter, at least one number */
const StrongPasswordSchema = z
  .string()
  .min(8, 'Password must be at least 8 characters')
  .regex(/[A-Z]/, 'Password must contain at least one uppercase letter')
  .regex(/[0-9]/, 'Password must contain at least one number');

export const LoginSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: z.string().min(1, 'Password is required'),
});

export const SignupSchema = z.object({
  email: z.string().email('Invalid email address'),
  password: StrongPasswordSchema,
  name: z.string().min(1, 'Name is required'),
});

export const ForgotPasswordSchema = z.object({
  email: z.string().email('Invalid email address'),
});

export const ResetPasswordSchema = z.object({
  token: z.string().min(1, 'Token is required'),
  password: StrongPasswordSchema,
});

export type Profile = z.infer<typeof ProfileSchema>;
export type LoginInput = z.infer<typeof LoginSchema>;
export type SignupInput = z.infer<typeof SignupSchema>;
export type ForgotPasswordInput = z.infer<typeof ForgotPasswordSchema>;
export type ResetPasswordInput = z.infer<typeof ResetPasswordSchema>;
/** @deprecated Use role object from AuthUser instead */
export type UserRoleEnum = string;
